exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hb-logo{display:inline-block;padding:10px 10px 10px 20px}.hb-logo a{text-decoration:none}.hb-logo a .fa{font-size:17px;color:#e07541}.hb-logo a span{color:#fff;font-weight:300;margin-left:5px;font-size:18px}", ""]);

// exports
